import { Component, OnInit, Input } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
    template: `<input type="number" id="pallet_{{rowData.id}}_qty" class="form-control" min="1" value="{{value}}" />`,
})
export class PalletQtyRenderComponent implements ViewCell, OnInit {

    @Input() value: string | number;
    @Input() rowData: any;

    ngOnInit() {
        //console.log(this.rowData);
    }
}





// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/details-view/pallet-qty-render.component.ts